<template>
    <div 
        :class="['a-p-list-item', dark ? 'a-p-list-item--dark' : '']"
        :style="customStyle"
    >
        <div 
            class="a-p-list-item__title"
            ref="title"
        >
            <template v-if="isCapitalise">
                {{title | capitalize}}
            </template>
            <template v-else>
                {{title}}
            </template>
        </div>
        <slot>
            <div 
                class="a-p-list-item__floor"
                :style="{
                    'backgroundColor': configFloorColor ? configFloorColor : '',
                    color: !configFloorColor ? floorColor : '',
                }"
            >
                {{floor}}
            </div>
            <div
                class="a-p-list-item__nr"
                :style="{
                    'backgroundColor': !configFloorColor ? floorColor : '',
                    height: `calc(${customStyle.lineHeight} - 0.104vw)`,
                }"
                v-html="nr"
            />
        </slot>
    </div>
</template>

<script>
import {capitalize} from '../../../utils/helpers/capitalize'
export default {
    name: 'APListItem',
    props: {
        title: {
            type: String,
            default: ''
        },
        dark: {
            type: Boolean,
            default: false
        },
        floor: {
            type: [Number, String],
            default: '-'
        },
        floorColor: {
            type: String,
            default: ''
        },
        configFloorColor: {
            type: String,
            default: ''
        },
        nr: {
            type: [Number, String],
            default: '-'
        },
        customStyle: {
            type: Object,
            default: () => ({})
        },
        isCapitalise: {
            type: Boolean,
            default: true
        }
    },
    filters: {
        capitalize
    }
}
</script>

<style lang="scss">
@import "a-p-list-item";
</style>
